import React from "react";
import { NewTab, PageTab } from "../../../../components";

import InputList from "./FormList/InputList";
import SelectList from "./FormList/SelectList";
import TextEditorList from "./FormList/TextEditorList";
import PasswordList from "./FormList/PasswordList";
import DatePickerList from "./FormList/DatePickerList";
import CheckboxList from "./FormList/CheckboxList";
import RadioList from "./FormList/RadioList";
import MailIdList from "./FormList/MailIdList";
import MonthPickerList from "./FormList/MonthPickerList";
import TextAreaList from "./FormList/TextAreaList";
import PhoneList from "./FormList/PhoneList";
import EmailList from "./FormList/EmailList";
import ToggleList from "./FormList/ToggleList";
import FileList from "./FormList/FileList";
import FileUploadList from "./FormList/FileUploadList";
import TagList from "./FormList/TagList";



const FormsList = () => {
  const tabList = [
    {
      title: "Tag",
      page: <TagList />,
      type: "main",
    },
    {
      title: "Radio",
      page: <RadioList />,
      type: "main",
    },
    {
      title: "Checkbox",
      page: <CheckboxList />,
      type: "main",
    },
    {
      title: "Input",
      page: <InputList />,
      type: "main",
    },
    {
      title: "Select",
      page: <SelectList />,
      type: "main",
    },
    {
      title: "Date Picker",
      page: <DatePickerList />,
      type: "main",
    },
    {
      title: "Month Picker",
      page: <MonthPickerList />,
      type: "main",
    },
    {
      title: "TextEditor",
      page: <TextEditorList />,
      type: "main",
    },
    {
      title: "Password",
      page: <PasswordList />,
      type: "main",
    },
    {
      title: "MailIds",
      page: <MailIdList />,
      type: "main",
    },
    {
      title: "TextArea",
      page: <TextAreaList />,
      type: "main",
    },
    {
      title: "Phone",
      page: <PhoneList />,
      type: "main",
    },
    {
      title: "Email",
      page: <EmailList />,
      type: "main",
    },
    {
      title: "Toggle",
      page: <ToggleList />,
      type: "main",
    },
    {
      title: "File",
      page: <FileList />,
      type: "main",
    },
    {
      title: "File List",
      page: <FileUploadList />,
      type: "main",
    },
  ];
  return (
    <div className="w-full p-2 flex flex-1 overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="forms-list"
      />
    </div>
  );
};

export default FormsList;
